import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex h-full flex-col items-center justify-center space-y-4 py-16 text-center">
      <h1 className="text-4xl font-extrabold text-brand-navy">404</h1>
      <p className="text-sm text-slate-500">The page you requested could not be found.</p>
      <Button asChild variant="outline">
        <Link to="/my-tasks">Return to My Tasks</Link>
      </Button>
    </div>
  );
}
